import { render, staticRenderFns } from "./repair.vue?vue&type=template&id=4939b2ce&scoped=true&"
import script from "./repair.vue?vue&type=script&lang=js&"
export * from "./repair.vue?vue&type=script&lang=js&"
import style0 from "./repair.vue?vue&type=style&index=0&id=4939b2ce&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4939b2ce",
  null
  
)

export default component.exports